import React from 'react';
import Page from '../../layout/Page';
import Deals from './Deals';
import PushNotifications from './PushNotifications';
import LoyaltyPoints from './LoyaltyPoints';
import ReferralProgram from './ReferralProgram';
import BirthdayClub from './BirthdayClub';
import AirPay from './AirPay';
import GiftEmail from './GiftEmail';
import Locations from './Locations';
import Settings from './Settings';
import PageBreak from '../../layout/PageBreak';
import PromoCodes from './PromoCodes';
import { userRoles } from '../../RoleProtected';
import Button from '../../forms/Button';
import ModalFactory from '../../Modal';
import HamQuest from '../../api/HamQuestGiver';
import { QuestRoute } from '../../api/QuestRoutes';
import Surveys  from './Surveys';

export const releaseAllDeviceIDs = () => {
    ModalFactory.confirmAndProcess({
        confirmation: {
            type: 'warning',
            title: 'Warning',
            body: 'You are about to release the device IDs across all mobile app users, are you sure?',
            slideToAccept: true,
        },
        promise: {
            title: 'Releasing',
            body: 'Releasing all device IDs',
            callback: () => HamQuest.delete(QuestRoute.settings.deleteDeviceIDs)
        },
        confirmed: {
            title: 'Released',
            body: 'All device IDs successfully released',
        }
    })
}

const Mobile = ({ ...props }) => {

    return (
        <Page
            title='Mobile App'
            tabTitle='Mobile App'
            icon='mobile'
            controls={<Button roles={userRoles.admin} onClick={releaseAllDeviceIDs}>Release All Device IDs</Button>}
            tabs
        >
            <PageBreak tab='Deals' >
                <Deals />
                <PromoCodes />
            </PageBreak>
            <PushNotifications tab='Push Notifications' roles={userRoles.notifications} />
            <LoyaltyPoints tab='Loyalty Points' roles={userRoles.accountConfiguration} />
            <ReferralProgram tab='Referral Program' roles={userRoles.accountConfiguration} />
            <BirthdayClub tab='Birthday Club' roles={userRoles.accountConfiguration} />
            <AirPay tab='AirPAY' roles={userRoles.accountConfiguration} />
            <GiftEmail tab='Gift Email Details' roles={userRoles.accountConfiguration} />
            <Locations tab='Locations' roles={userRoles.accountConfiguration} />
            <Settings tab='Settings' roles={userRoles.accountConfiguration} />
            <Surveys tab='Survey Results' />
        </Page >
    );
}

export default Mobile;